module.exports = __webpack_public_path__ + "static/media/track-bg-single.dc22a7fe.png";